import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Divider, Flex, XOutline } from '@bonusly/design-system';

import { useScreenSize } from '../../hooks/useScreenSize';

export interface InputControlsProps {
	onClearValue: VoidFunction;
	onClose: VoidFunction;
	value: string;
}

export const InputControls: FC<InputControlsProps> = ({ onClearValue, onClose, value }) => {
	const { isAtLeastSm } = useScreenSize();
	const { t } = useTranslation('common');

	if (!value && isAtLeastSm) {
		return null;
	}

	const displayDivider = !!value && !isAtLeastSm;

	return (
		<Flex alignItems="center" pr={2} pl={3}>
			{value && (
				<Button onClick={onClearValue} px={1} variant="link">
					{t('clear')}
				</Button>
			)}

			{displayDivider && <Divider color="gray.100" orientation="vertical" mx={2} />}

			{!isAtLeastSm && (
				<Flex as="button" alignItems="center" aria-label={t('close')} onClick={onClose}>
					<XOutline size="md" />
				</Flex>
			)}
		</Flex>
	);
};
